const state = {
  moneyboxes: {}
}

const getters = {

}

const actions = {
  requestMoneyboxList({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.moneyboxList()).then(function(response){
                  commit("_requestMoneyboxList", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestMoneyboxCreate({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.post(api.moneyboxCreate(), payload).then(function(response){
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestMoneyboxUnloadIntervalCreate({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.post(api.moneyboxUnloadIntervalCreate(payload.moneybox_id), payload).then(function(response){
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestMoneyboxDelete({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.delete(api.moneyboxDelete(payload)).then(function(response){
                  commit("_requestMoneyboxDelete", payload)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  } 
}

const mutations = {
  _requestMoneyboxList(state, payload){
    state.moneyboxes = payload
  },
  _requestMoneyboxDelete(state, payload){
    state.moneyboxes.moneyboxes.splice(state.moneyboxes.moneyboxes.findIndex(item=>item.id == payload), 1)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
